import * as React from "react"
import { Decoration } from "react-diff-view"

import { IHunk } from "./index"

interface HunkInfoProps {
    hunk: IHunk
}

const HunkInfo = (props: HunkInfoProps): JSX.Element => (
    <Decoration>{props.hunk.content}</Decoration>
)

export default HunkInfo
